import { theme } from '@theme';
import { Column } from 'react-table';
import { PortfolioResource } from '../../../../../types/PortfolioResource';
import Tooltip from '../../../../shared/tooltip/Tooltip';
import { Typography } from '../../../../style';
import BpsHeader from './BpsHeader';
import { getScoreValue } from './CashDealsColumn';

export const financeDealsColumns: Column<PortfolioResource>[] = [
  {
    Header: <BpsHeader iconSize={28} iconType='score-payment' toolTipText='Payment' />,
    id: 'payment',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_PaymentAmountPercentage}
      </Typography>
    ),
    sortAccessor: 'payment',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='score-equity' toolTipText='Equity' />,
    id: 'equity',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_EquityPercentage}
      </Typography>
    ),
    sortAccessor: 'equity',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='score-incentives' toolTipText='Incentives' />,
    id: 'incentives',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_IncentivePercentage}
      </Typography>
    ),
    sortAccessor: 'incentives',
    isSortable: true,
  },
  {
    Header: (
      <Tooltip
        trigger={
          <Typography size={28} className='ic-small-interest bps-header' color={theme.palette.gray}>
            %
          </Typography>
        }
        content={
          <Typography size={theme.typography.h5} color={theme.palette.lightGray}>
            Interest
          </Typography>
        }
        cssClass='portfolio-tooltip'
      />
    ),
    id: 'interest',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_InterestPercentage}
      </Typography>
    ),
    sortAccessor: 'interest',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='score-product' toolTipText='Product' />,
    id: 'product',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_ProductPercentage}
      </Typography>
    ),
    sortAccessor: 'product',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='score-warranty' toolTipText='Warranty' />,
    id: 'warranty',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_WarrantyPercentage}
      </Typography>
    ),
    sortAccessor: 'warranty',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='score-ownership' toolTipText='Ownership' />,
    id: 'ownership',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {original.replacementDeal.bps_OwnershipPercentage}
      </Typography>
    ),
    sortAccessor: 'ownership',
    isSortable: true,
  },
  {
    Header: <BpsHeader iconSize={28} iconType='ev-leaf' toolTipText='EV' />,
    id: 'ev',
    width: 10,
    minWidth: 10,
    Cell: ({ row: { original } }) => (
      <Typography size={theme.typography.h5} fontWeight={theme.typography.fontWeights.normal}>
        {getScoreValue(original.closedDeal.evPropensityScore)}
      </Typography>
    ),
    sortAccessor: 'ev',
    isSortable: true,
  },
];
